module.exports = "<nav class=\"leftsettingbox\">\r\n    <ul class=\"list-unstyled settinglist\">\r\n        <li>\r\n            <a [routerLink]=\"['engineOil']\" hasPermission=\"maintenance.EO.engineOil.active\" routerLinkActive=\"selected\">\r\n                <section>Engine Oil</section>\r\n            </a>\r\n          \r\n        </li>\r\n\r\n    </ul>\r\n</nav>\r\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/maintenance/EngineOil/engineOil.component.html
// module id = ./src/app/maintenance/EngineOil/engineOil.component.html
// module chunks = main